import { render, staticRenderFns } from "./aRoomDetailOwner.vue?vue&type=template&id=3181ef8c&scoped=true"
import script from "./aRoomDetailOwner.vue?vue&type=script&lang=js"
export * from "./aRoomDetailOwner.vue?vue&type=script&lang=js"
import style0 from "./aRoomDetailOwner.vue?vue&type=style&index=0&id=3181ef8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3181ef8c",
  null
  
)

export default component.exports